import { render, staticRenderFns } from "./MyCards.vue?vue&type=template&id=5f527df6&scoped=true"
import script from "./MyCards.vue?vue&type=script&lang=js"
export * from "./MyCards.vue?vue&type=script&lang=js"
import style0 from "./MyCards.vue?vue&type=style&index=0&id=5f527df6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f527df6",
  null
  
)

export default component.exports